import { useCallback } from "react";
import { useNavigate, useSearch } from "@tanstack/react-router";

const useQueryParams = (name: string, defaultState: string | null = null) => {
  const navigate = useNavigate();
  const value = useSearch({ strict: false, select: (search) => search[name] }) || defaultState;
  const setValue = useCallback(
    (newValue: string | null) => {
      void navigate({
        to: ".",
        search: (prev) => ({ ...prev, [name]: newValue === null || newValue === defaultState ? undefined : newValue }),
        replace: true,
        resetScroll: false,
      });
    },
    [navigate, name, defaultState],
  );
  return [value, setValue] as const;
};

export function useSetMultipleQueryParams() {
  const navigate = useNavigate();

  return useCallback(
    (params: Record<string, string | null>) => {
      void navigate({
        to: ".",
        search: (prev) => {
          const next = { ...prev };
          for (const [name, value] of Object.entries(params)) next[name] = value ?? undefined;
          return next;
        },
        replace: true,
        resetScroll: false,
      });
    },
    [navigate],
  );
}

export default useQueryParams;
